import React from 'react';
import { Stack, Typography } from '@mui/material';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
import { IEvent } from '../../types/global/helper';
import { LightbulbCircleOutlined } from '@mui/icons-material';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { RichTextViewer } from '../Common/RichTextViewer';

export interface IEventDescripiton {
    event: IEvent;
}

const EventDescription: React.FC<IEventDescripiton> = ({ event }) => {
    const { themeStyle } = useThemeContext();
    return (
        <React.Fragment>
            <Stack direction="row" gap={1}>
                <LightbulbCircleOutlined sx={{ color: theme[themeStyle].tag_white }} />
                <Typography
                    sx={{
                        fontWeight: 'bold',
                        fontFamily: FONT_ENUM.MAIN_BOLD,
                        fontSize: 18,
                        color: theme[themeStyle].tag_white,
                    }}>
                    Event Description
                </Typography>
            </Stack>

            <RichTextViewer content={event.description || 'No description provided'} textStyle={{ padding: 0 }} />
        </React.Fragment>
    );
};

export { EventDescription };
